import { HttpException } from './HttpException';

export class SurveyAlreadyCompletedException extends HttpException {
  static readonly API_CODE = 'SURVEY_ALREADY_COMPLETED';

  constructor(message: string, httpCode?: number) {
    super(message, httpCode);

    Object.setPrototypeOf(this, SurveyAlreadyCompletedException.prototype);
  }

  getApiCode(): string {
    return SurveyAlreadyCompletedException.API_CODE;
  }
}
